<form
    [formGroup]="form"
    (submit)="searchByClick()"
    class="box-border w-full h-12 flex items-center justify-between gap-2 px-2"
>
    <mat-form-field [formGroup]="form" class="input-search" appearance="outline">
        <div class="input-search-item">
            <ng-container *ngIf="positionIcon === 'left'">
                <div class="input-search-icon">
                    <i class="mdi mdi-{{ icon }}"></i>
                </div>
            </ng-container>
            <input
                #searchInput
                matInput
                formControlName="searchStr"
                type="text"
                class="input-search-value"
                [class.input-search-value-left-padding]="positionIcon === 'left'"
                [placeholder]="label"
            />
            <app-button
                *ngIf="searchStr$ | async"
                (clickEvent)="clearForm()"
                [title]="appService.language_dictionary.system_clear"
                type="button-icon"
                height="slim"
                color="flat"
                borderRadius="circle"
                icon="close"
                iconSize="14"
            >
            </app-button>
            <div class="input-search-icon-group" *ngIf="showToggleArrowButtons">
                <app-button
                    #arrowDownButton
                    (clickEvent)="arrowDownClick()"
                    [disabled]="disableDown"
                    [title]="appService.language_dictionary.factor_down"
                    [type]="'button-icon'"
                    [height]="'slim'"
                    [color]="'flat'"
                    [borderRadius]="'circle'"
                    icon="arrow-down-thin"
                    [iconSize]="16"
                >
                </app-button>
                <app-button
                    #arrowUpButton
                    (clickEvent)="arrowUpClick()"
                    [disabled]="disableUp"
                    [title]="appService.language_dictionary.factor_up"
                    [type]="'button-icon'"
                    [icon]="'arrow-up-thin'"
                    [height]="'slim'"
                    [color]="'flat'"
                    [borderRadius]="'circle'"
                    [iconSize]="16"
                >
                </app-button>
            </div>
        </div>
    </mat-form-field>

    <app-button
        *ngIf="positionIcon === 'right'"
        (clickEvent)="searchByClick()"
        [title]="appService.language_dictionary.system_search"
        type="button-icon"
        [icon]="icon"
        height="slim"
        color="flat"
        borderRadius="circle"
        iconSize="16"
    >
    </app-button>
</form>
